import { IconImg } from "contents/Images";
import { StyledRegacy__Chip } from "./regacy__style";
import { SetStateAction, useEffect, useState } from "react";

export interface ChipProps {
  label: string;
  close: boolean;
  type: "blue" | "gray" | "line";
  color?: "red";
  size?: "xs" | "s";
  width?: string;
  deleteChip?: (key: any) => void;
  deleteKey?: any;
  isSort?: boolean;
  setSort?: (target: string, order: "asc" | "desc") => void;
  sort?: "asc" | "desc" | null;
  onClick?: () => void;
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

function Regacy__Chip({
  label,
  close,
  type,
  size,
  width = "100%",
  deleteChip,
  deleteKey,
  isSort = false,
  setSort,
  sort = "asc",
  color,
  onClick = () => {},
  onMouseDown = () => {},
}: ChipProps) {
  const handleDeleteChip = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    deleteKey && deleteChip?.(deleteKey);
  };

  return (
    <StyledRegacy__Chip
      type={type}
      size={size ? size : "s"}
      width={width}
      onClick={onClick}
    >
      <span className="chip">
        <p className={`label ${color === "red" && "red"}`}>{label}</p>

        {isSort && (
          <button
            className={`sort ${sort}`}
            onClick={(e) => {
              e.stopPropagation();
              setSort && setSort(label, sort === "asc" ? "desc" : "asc");
            }}
          >
            {sort === "asc" ? "ASC" : "DESC"}
            <span className="sort-icon-wrap">
              <IconImg.ArrowDescending />
            </span>
          </button>
        )}

        {close && deleteChip && (
          <button
            className="delete-btn"
            onClick={handleDeleteChip}
            onMouseDown={(e) => {
              e.stopPropagation();
              onMouseDown(e);
            }}
          >
            <IconImg.XClose />
          </button>
        )}
      </span>
    </StyledRegacy__Chip>
  );
}
export default Regacy__Chip;
